import React from "react";
import { connect } from "react-redux";
import Security from "./universe_lite/Security/security_universe";
import Analyze from "./universe_lite/Analyze/analyze";

function UniverseLite({ analyzeExistingActive }) {
  return (
    <div className="universe_lite">
      <div className="universe__table">
        {analyzeExistingActive ? <Analyze /> : <Security />}
      </div>
    </div>
  );
}

export default connect(
  ({
    create: {
      steps: {
        universeLite: { analyzeExistingActive },
      },
    },
  }) => ({
    analyzeExistingActive,
  }),
  null
)(UniverseLite);



// WEBPACK FOOTER //
// ./src/components/pages/Create/UniverseLite.jsx